import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createRole } from '../../api';

const AddRole = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        permissions: '', // Comma-separated permissions
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            const permissionsArray = formData.permissions
                .split(',')
                .map((perm) => perm.trim());
            await createRole({ name: formData.name, permissions: permissionsArray });
            alert('Role created successfully!');
            navigate('/roles');
        } catch (error) {
            alert('Error creating role!');
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={3}>
            <Typography variant="h5" mb={2}>
                Add Role
            </Typography>
            <TextField
                label="Role Name"
                name="name"
                fullWidth
                margin="normal"
                onChange={handleChange}
            />
            <TextField
                label="Permissions (comma-separated)"
                name="permissions"
                fullWidth
                margin="normal"
                onChange={handleChange}
            />
            <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                <Button variant="contained" color="secondary" onClick={() => navigate('/roles')}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    Add Role
                </Button>
            </Box>
        </Box>
    );
};

export default AddRole;
